import { render, staticRenderFns } from "./ControlsWrap.vue?vue&type=template&id=6e1604cb&scoped=true&"
import script from "./ControlsWrap.vue?vue&type=script&lang=js&"
export * from "./ControlsWrap.vue?vue&type=script&lang=js&"
import style0 from "./ControlsWrap.vue?vue&type=style&index=0&id=6e1604cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1604cb",
  null
  
)

export default component.exports